<template>
  <div>
      <h2>Child1</h2>
    <compSix/>
      {{localHui}}
      <button @click="incCounter"></button>
  </div>
</template>

<script>
import compSix from "./comp6";

export default {

    components:{
        compSix
    },
        
    computed: {
        localHui:{
            get(){
                return this.hui
            },
            set(value){
                this.$emit('update:hui',value)
            }
        }
    },
    methods:{
        incCounter(){
            ++this.localHui
        },
    },
    props:{
        hui: Number
    }
}
</script>

<style>

</style>